const FOLIO_1_200_RE = /^[A-Z0-9_-]{1,200}$/;
const FOLIO_1_20_RE = /^[A-Z0-9_-]{1,20}$/;
const NUMERO_NOTARIO_RE = /^[A-Z0-9_-]{1,8}$/;
const DIRECCION_ARI_RE = /^[A-ZÑ0-9 \-.,:/()]{1,}$/;

export interface DatosInmMinimos {
  colonia: string;
  calle: string;
  numeroExterior: string;
  codigoPostal: string;
  terreno: string;
  construido: string;
  folioReal: string;
  instrumentoTipo: string;
  fechaContrato: string;
  numeroInstrumento: string;
  fechaInstrumento: string;
  notario: string;
  entidadInstrumento: string;
  avaluo: string;
}

export interface DatosAriMinimos {
  colonia: string;
  calle: string;
  numeroExterior: string;
  codigoPostal: string;
  folioReal: string;
  fechaInicio: string;
  fechaTermino: string;
}

export function faltantesDatosInm(datos: DatosInmMinimos): string[] {
  const faltantes: string[] = [];
  if (!datos.colonia.trim()) faltantes.push("colonia");
  if (!datos.calle.trim()) faltantes.push("calle");
  if (!datos.numeroExterior.trim()) faltantes.push("número exterior");
  if (!/^\d{5}$/.test(datos.codigoPostal.trim())) faltantes.push("código postal de 5 dígitos");
  if ((Number(datos.terreno) || 0) <= 0) faltantes.push("dimensión de terreno");
  if ((Number(datos.construido) || 0) <= 0) faltantes.push("dimensión construida");
  const folioReal = datos.folioReal.trim();
  if (!folioReal) faltantes.push("folio real");
  else if (!FOLIO_1_200_RE.test(folioReal)) faltantes.push("folio real sin espacios ni puntos");
  if (datos.instrumentoTipo === "instrumento_publico") {
    const numeroInstrumento = datos.numeroInstrumento.trim();
    const notario = datos.notario.trim();
    if (!numeroInstrumento) faltantes.push("número de instrumento público");
    else if (!FOLIO_1_20_RE.test(numeroInstrumento)) faltantes.push("número de instrumento público sin espacios ni puntos");
    if (!datos.fechaInstrumento) faltantes.push("fecha de instrumento público");
    if (!notario) faltantes.push("notario");
    else if (!NUMERO_NOTARIO_RE.test(notario)) faltantes.push("notario sin espacios ni puntos");
    if (!datos.entidadInstrumento) faltantes.push("entidad del instrumento público");
    if ((Number(datos.avaluo) || 0) <= 0) faltantes.push("valor de avalúo catastral");
  } else if (!datos.fechaContrato) {
    faltantes.push("fecha de contrato");
  }
  return faltantes;
}

export function faltantesDatosAri(datos: DatosAriMinimos): string[] {
  const faltantes: string[] = [];
  const colonia = datos.colonia.trim();
  const calle = datos.calle.trim();
  const numeroExterior = datos.numeroExterior.trim();
  if (!colonia) faltantes.push("colonia");
  else if (!DIRECCION_ARI_RE.test(colonia)) faltantes.push("colonia sin #, comillas ni corchetes");
  if (!calle) faltantes.push("calle");
  else if (!DIRECCION_ARI_RE.test(calle)) faltantes.push("calle sin #, comillas ni corchetes");
  if (!numeroExterior) faltantes.push("número exterior");
  else if (!DIRECCION_ARI_RE.test(numeroExterior)) faltantes.push("número exterior sin #, comillas ni corchetes");
  if (!/^\d{5}$/.test(datos.codigoPostal.trim())) faltantes.push("código postal de 5 dígitos");
  const folioReal = datos.folioReal.trim();
  if (!folioReal) faltantes.push("folio real");
  else if (!FOLIO_1_200_RE.test(folioReal)) faltantes.push("folio real sin espacios ni puntos");
  if (!datos.fechaInicio) faltantes.push("fecha de inicio del contrato");
  if (!datos.fechaTermino) faltantes.push("fecha de término del contrato");
  return faltantes;
}
